import { Alert } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
const BeingProcessed = () => {
    const { t } = useTranslation();
    return (<Alert title={t('financing.being_processed.title')} variant="info">
            <div className="body-m">{t('financing.being_processed.message')}</div>
        </Alert>);
};
export default BeingProcessed;
